import axios from 'axios';
import { RESPONSE_SUCCESS } from './api-constant';


const api = axios.create({
    // baseURL: prodHost prod url
    baseURL: "https://api.blogsfluent.com/api/"
    // baseURL: "http://localhost:8000/api/",

});

export const createApiCall = async (method, url, payload = "", return_status = false,headers={'Content-Type': 'application/json'}) => {

    if (method === "GET") {
        const { data } = await api.get(url)
        if (data?.response === RESPONSE_SUCCESS) {
            if (return_status) {
                return data
            }
            return data?.data
        }
       
    }
    if (method === "POST") {
        const { data } = await api.post(url, payload,{
            headers:headers
        })

        // return data
        if (data?.response === RESPONSE_SUCCESS) {
            if (return_status) {
                return data
            }
            return data?.data
        }
    }
    if (method === "PUT") {
        const { data } = await api.put(url, payload === "" ? {} : payload)
        // if (data?.status?.code === STATUS_SUCCESS_CODE) {
        //     if (return_status) {
        //         return data
        //     }
        //     return data?.data
        // }

    }
    if (method === "DELETE") {
        const { data } = await api.delete(url, payload === "" ? {} : payload)
        // if (data?.status?.code === STATUS_SUCCESS_CODE) {
        //     return data?.data
        // }

    }

    if (method === "BLOB") {
        const data = await api.post(url, payload, { responseType: 'blob' })
        console.log(data)
        return data.data
    }
}
